import service from '@/store/services/invoices/vouchers-service';

const state = {
    list: {},
    voucher: {},
    meta: {},
    statistics: {},
    url: null,
    dashboard: {
        summary: {
            invoice: {},
            voucher: {}
        },
        statuses: [],
        stations: [],
        departments: [],
        vendors: []
    },

    dashboardLoading: false,
    dashboardError: null
};

const mutations = {
    SET_LIST: (state, list) => {
        state.list = list;
    },
    SET_RESOURCE: (state, voucher) => {
        state.voucher = voucher;
    },
    SET_META: (state, meta) => {
        state.meta = meta;
    },
    SET_URL: (state, url) => {
        state.url = url;
    },
    SET_DASHBOARD(state, dashboard) {
        state.dashboard = dashboard;
    },

    SET_DASHBOARD_LOADING(state, value) {
        state.dashboardLoading = value;
    },

    SET_DASHBOARD_ERROR(state, error) {
        state.dashboardError = error;
    },
    SET_STATISTICS: (state, statistics) => {
        state.statistics = statistics;
    }
};

const actions = {
    list ({ commit, dispatch }, params) {
        return service.list(params)
            .then(({ list, meta }) => {
                commit('SET_LIST', list);
                commit('SET_META', meta);
            });
    },

    get ({ commit, dispatch }, params) {
        return service.get(params)
            .then((voucher) => {
                commit('SET_RESOURCE', voucher);
            });
    },
    execute ({ commit, dispatch }, params) {
        return service.execute(params)
            .then((voucher) => {
                commit('SET_RESOURCE', voucher);
            });
    },

    add ({ commit, dispatch }, params) {
        return service.add(params)
            .then((voucher) => {
                commit('SET_RESOURCE', voucher);
            });
    },

    update ({ commit, dispatch }, params) {
        return service.update(params)
            .then((voucher) => {
                commit('SET_RESOURCE', voucher);
            });
    },

    destroy ({ commit, dispatch }, params) {
        return service.destroy(params);
    },
    update1 ({ commit, dispatch }, params) {
        return service.update1(params)
            .then((voucher) => {
                commit('SET_RESOURCE', voucher);
            });
    },
    statusStatistics ({ commit, dispatch }, params) {
        return service.getStatusStatistics(params)
            .then((statistics) => {
                commit('SET_STATISTICS', statistics);
            });
    },
    forceReject({ commit }, { id, force_reject }) {
        return service.forceReject(id, force_reject)
            .then(response => {
                return response;
            });
    },
    async fetchDashboard(
        { commit },
        filters = {}
    ) {

        commit(
            'SET_DASHBOARD_LOADING',
            true
        );

        commit(
            'SET_DASHBOARD_ERROR',
            null
        );

        try {

            const response = await service.getDashboard(
                filters
            );

            commit(
                'SET_DASHBOARD',
                response.data
            );

            return response.data;

        } catch (error) {

            commit(
                'SET_DASHBOARD_ERROR',
                error
            );

            throw error;

        } finally {

            commit(
                'SET_DASHBOARD_LOADING',
                false
            );
        }
    }
};

const getters = {
    list: state => state.list,
    listTotal: state => state.meta.page.total,
    voucher: state => state.voucher,
    statistics: state => state.statistics,
    dropdown: (state) => {
        return state.list.map(voucher => ({
            id: voucher.id,
            voucher_number: voucher.voucher_number
        }));
    },
    url: state => state.url
};

const vouchers = {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
};

export default vouchers;
